/**
 * Enum for Leaflet version compatibility.
 */
export enum LeafletVersion {
  V1 = '1.x',
  V2 = '2.x',
}

/**
 * Enum for drawing modes in Polydraw.
 */
// TODO: We have DrawModes in different places, refactor!
export enum DrawMode {
  Off = 0,
  Add = 1,
  Edit = 2,
  Subtract = 4,
  AppendMarker = 8,
  LoadPredefined = 16,
  PointToPoint = 32,
  PointToPointSubtract = 64,
  Clone = 128,
}
/**
 * Enum for marker positions.
 */
// TODO: Add centerOfMass and BoundingBoxCenter
// Issue: For the above, we can't use the polygon edges, we have to add stand alone divIcons
export enum MarkerPosition {
  SouthWest = 0,
  South = 1,
  SouthEast = 2,
  East = 3,
  NorthEast = 4,
  North = 5,
  NorthWest = 6,
  West = 7,
  Hole = 8,
  // CenterOfMass = 9,
  // BoundingBoxCenter = 10
}

export enum DonutDirection {
  Both = 'both',
  Inward = 'inward',
}
